import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';

const chartConfig = {
  count: {
    label: "Deals",
    color: "hsl(var(--destructive))",
  },
};

// Color scale from warning to destructive based on count
const getBarColor = (count, maxCount) => {
  if (maxCount === 0) return 'hsl(var(--muted))';
  const ratio = count / maxCount;
  if (ratio > 0.7) return 'hsl(var(--destructive))';
  if (ratio > 0.4) return 'hsl(var(--warning))';
  return 'hsl(var(--chart-3))';
};

export default function DealsWithoutScheduledCallsChart({ 
  data = [], 
  loading = false,
  onBarClick 
}) {
  if (loading) {
    return (
      <div className="h-[300px] flex items-center justify-center text-muted-foreground">
        Loading...
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="h-[300px] flex items-center justify-center text-muted-foreground">
        All deals have scheduled calls
      </div>
    );
  }

  const maxCount = Math.max(...data.map(d => d.count));
  
  // Prepare data for horizontal bar chart
  const chartData = data.slice(0, 10).map(item => ({
    name: item.consultant_name.split(' ')[0], // First name only
    fullName: item.consultant_name,
    count: item.count,
    consultant_id: item.consultant_id,
    deals: item.deals
  }));

  return (
    <ChartContainer config={chartConfig} className="h-[300px] w-full">
      <BarChart 
        data={chartData} 
        layout="vertical"
        margin={{ left: 0, right: 20, top: 5, bottom: 5 }}
      >
        <XAxis 
          type="number" 
          tickLine={false} 
          axisLine={false}
          fontSize={12}
          allowDecimals={false}
        />
        <YAxis 
          type="category"
          dataKey="name" 
          tickLine={false} 
          axisLine={false}
          fontSize={12}
          width={80}
        />
        <ChartTooltip 
          content={({ active, payload }) => {
            if (!active || !payload?.length) return null;
            const item = payload[0].payload;
            return (
              <div className="bg-popover border rounded-lg shadow-lg p-3">
                <p className="font-medium">{item.fullName}</p>
                <p className="text-sm text-muted-foreground">
                  {item.count} deals sem call agendada
                </p>
              </div>
            );
          }}
        />
        <Bar 
          dataKey="count" 
          radius={[0, 4, 4, 0]}
          cursor="pointer"
          onClick={(data) => onBarClick?.(data.deals, data.fullName)}
        >
          {chartData.map((entry, index) => (
            <Cell 
              key={`cell-${index}`} 
              fill={getBarColor(entry.count, maxCount)}
            />
          ))}
        </Bar>
      </BarChart>
    </ChartContainer>
  );
}
